import { render } from "./SliderIndicatorPage.vue?vue&type=template&id=40bc2036&scoped=true"
import script from "./SliderIndicatorPage.vue?vue&type=script&lang=js"
export * from "./SliderIndicatorPage.vue?vue&type=script&lang=js"

import "./SliderIndicatorPage.vue?vue&type=style&index=0&id=40bc2036&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40bc2036"]])

export default __exports__